<template>
  <div>
    <div class="">
      <v-speed-dial
        v-model="fab"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
      >
        <template v-slot:activator>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-model="fab"
                v-bind="attrs"
                v-on="on"
                fab
                icon
                x-small
                class="micro-btn"
              >
                <v-icon v-if="fab" color="pink darken-1" size="16"
                  >mdi-close</v-icon
                >
                <span v-else class="svg-icon svg-icon-dark svg-icon-2x">
                  <svg
                    height="18px"
                    version="1.1"
                    viewBox="0 0 24 24"
                    width="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0" />
                      <circle cx="12" cy="5" fill="#000000" r="2" />
                      <circle cx="12" cy="12" fill="#000000" r="2" />
                      <circle cx="12" cy="19" fill="#000000" r="2" />
                    </g>
                  </svg>
                </span>
              </v-btn>
            </template>
            <span>{{ $t("actions") }}</span>
          </v-tooltip>
        </template>

        <v-tooltip v-for="(item, index) in meta.buttons" :key="index" left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="item.condition ? validation(item) : true"
              v-status="item.status"
              :class="classBtn + item.class + ' micro-btn'"
              v-bind="attrs"
              v-on="on"
              fab
              x-small
              @click.stop="item.action(data, item.name)"
            >
              <i :class="iconClass + item.icon"></i>
            </v-btn>
          </template>
          <span>{{ item.label }}</span>
        </v-tooltip>
      </v-speed-dial>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerticalButtons",
  props: {
    data: {},
    action: {
      type: Function,
    },
    meta: {
      type: Object,
    },
  },
  data() {
    return {
      classBtn: "btn btn-sm text-center ",
      iconClass: "px-1 text-center fa fa-",
      direction: "bottom",
      color: {
        edit: "warning",
        delete: "error",
        show: "info",
        refresh: "indigo",
      },
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-transition",
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    validation(item) {
      if (this.data.payment) {
        return item.condition(this.data.payment);
      } else if (this.data.deleted_at) {
        return item.condition(this.data.deleted_at);
      } else if (this.data.provider === "divar_shop") {
        return item.condition("فروشگاه");
      } else if (this.data.data) {
        return item.condition(this.data.data.status || this.data.status);
      } else return true;
    },
  },
};
</script>

<style scoped>
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}

.v-btn.micro-btn {
  height: 26px !important;
  width: 26px !important;
  min-width: 26px !important;
}

.v-btn.micro-btn .v-icon {
  font-size: 16px !important;
}

.v-btn.micro-btn i {
  font-size: 12px !important;
}
</style>
